import React from 'react';
import css from './progress.module.scss';

interface ProgressProps {
	progress: number;
}

const Progress: React.FC<ProgressProps> = ({ progress }): JSX.Element => {
	return (
		<div className={css.progress}>
			<div
				className={css['progress-bar']}
				style={{ width: progress + '%' }}
			></div>
		</div>
	);
};

export default Progress;
